module.exports = __webpack_public_path__ + "static/media/hero.c13f3db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/storingmelden/hero.jpg
// module id = 911
// module chunks = 0